import React from 'react'
import RowItemBus from '../row-item-bus/row-item-bus'

const ListRowSecond: React.FunctionComponent = () => {
  return (
    <>
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={'escaleras'} row5={'escaleras'} />
      <RowItemBus row1={1} row2={2} row3={null} row4={null} row5={null} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={3} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={3} row5={4} />
    </>
  )
}

export default ListRowSecond